import { render, staticRenderFns } from "./ProgrammaticTargetForm.vue?vue&type=template&id=6983ac2e"
import script from "./ProgrammaticTargetForm.vue?vue&type=script&lang=js"
export * from "./ProgrammaticTargetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports